<div [formGroup]="bookWidgetForm" class="row multicity-header-align">
  <div class="col-12 pl-lg-0" formArrayName="flights">
    <ngc-flightitem
      #flightRow
      (destAirportSet)="flightItemDestSet($event)"
      *ngFor="let item of getFlights(bookWidgetForm); let i = index"
      [bookContent]="bookContent"
      [errorHandler]="errorHandler"
      [flightData]="item.value"
      [flightFormGroup]="item"
      [index]="i"
    ></ngc-flightitem>

    <div class="row multicity-header-align multicity-add-remove-flight-panel">
      <div class="p-sm-0 col-6">
        <a
          #addFlightButton
          (click)="addFlight()"
          *ngIf="getFlights(bookWidgetForm).length < 6"
          class="add-flight icon-Add-Flight"
          href="javascript:void(0)"
          role="button"
        >
          {{ bookContent?.addFlightLabel }}
        </a>
      </div>

      <div class="p-sm-0 col-6 text-right">
        <a
          (click)="removeFlight()"
          *ngIf="getFlights(bookWidgetForm).length >= 3"
          class="remove-flight icon-Remove-Flight"
          href="javascript:void(0)"
          role="button"
        >
          {{ bookContent?.removeFlightLabel }}
        </a>
      </div>

      <div aria-atomic="true" aria-live="assertive" class="sr-only">
        {{ flightRemovedLable }}
      </div>
    </div>
  </div>
</div>
